import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
export default Object.freeze({
  [FieldTypes.CHOICE]: {
    BUTTONS: 'buttons',
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    SELECT: 'select'
  },
  [FieldTypes.NUMBER]: {
    TEXT: 'text',
    SLIDER: 'slider'
  },
  [FieldTypes.BOOLEAN]: {
    TOGGLE: 'toggle',
    CHECKBOX: 'checkbox'
  }
});